<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-12-21 14:15:58
 -->
<template>
  <div class="pi-popup-content"
       v-if="show">
    <div class="opacity"
         :class="classShow ? 'opacity-show' : 'opacity-hide'"
         @click="close"></div>
    <div class="content-box-bottom" v-if="type == 'bottom'" :class="classShow ? 'bottom-show' : ''">
      <slot></slot>
    </div>
    <div v-else class="content-box"
         :class="classShow ? 'div-scale' : 'div-scaleHide'">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pi-popup-content',
  data () {
    return {
      show: false,
      classShow: false
    };
  },
  methods: {
    open () {
      this.show = true;
      // setTimeout(() => {
      this.classShow = true;
      // });
    },
    close () {
      this.classShow = false;
      setTimeout(() => {
        this.show = false;
      }, 300);
    }
  },
  mounted () {

  },
  props:{
    type: {
      type:String,
      default: '',
    },
  }
};
</script>

<style lang="less" scoped>
.opacity {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 6;
}
.content-box {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 7;
}
.content-box-bottom{
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 7;
  background-color: #fff;
  border-radius: 0.2rem 0;
  transition: 0.3s;
  transform: translate(0, 100%);
}
.content-box-bottom.bottom-show{
 transform: translate(0, 0%);
}
</style>
